const debugCondition = process.env.CONTEXT !== 'production'

export const logDebugMessage = (...args: any[]) =>
  debugCondition && console.log(...args)

export const errorDebugMessage = (...args: any[]) =>
  debugCondition && console.error(...args)
